export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_MFA_TOKEN = 'SET_MFA_TOKEN'
export const SET_MFA_USER = 'SET_MFA_USER'
export const CLEAR_MFA = 'CLEAR_MFA'
